import React, { Component } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Switch from 'react-bootstrap-switch';
import {getCallForward,setInconditionalDivert,setConditionalDivert} from '../../actions/callForward';
import Loader from '../Components/Loader';
import { logData, keyDownHandler, pasteHandler } from '../../utils/utils';
import "../../agent/Styles/darktheme.css";
import "../../agent/Styles/blacktheme.css";
import "../../agent/Styles/highContrast.css";
class EditRedirectModal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      isShow: false,
      call_forward: this.props.callForward.call_forward,
      phone: this.props.callForward.phone!==undefined ? this.props.callForward.phone : '' ,
      showData: false
    };
  }

  componentWillReceiveProps = (nextProp) => {
    if (JSON.stringify(this.props.callForward) !== JSON.stringify(nextProp.callForward) || nextProp.showRedirectionModal == true) {
      this.setState({
        call_forward: nextProp.callForward.call_forward!==undefined ? nextProp.callForward.call_forward : false,
        phone: nextProp.callForward.phone!==undefined ? nextProp.callForward.phone : '',
        busy_call_forward: nextProp.callForward.busy_call_forward!==undefined ? nextProp.callForward.busy_call_forward : false,
        busy_phone_call_forward: nextProp.callForward.busy_call_forward!==undefined ? nextProp.callForward.busy_phone_call_forward : '',
        noanswer_call_forward: nextProp.callForward.noanswer_call_forward!==undefined ? nextProp.callForward.noanswer_call_forward : false,
        noanswer_phone_call_forward: nextProp.callForward.noanswer_phone_call_forward!==undefined ? nextProp.callForward.noanswer_phone_call_forward : '',
        noanswer_time_call_forward: nextProp.callForward.noanswer_time_call_forward!==undefined ? nextProp.callForward.noanswer_time_call_forward : '',
      })
    }
  }
  /**
   * closes the modal
   * @param  {string} key
   */
  close = (key) => {
    this.setState({
      showErr: false
    }, () => {
      this.props.handleClose(key);
    })
  }
  // gets call forwarding data
  getCallForwardStatus = () => {
    this.setState({
      showData: false
    }, () => {
      this.props.getCallForward().then(() => {
        this.setState({
          showData: true
        });
      }, (err) => {
        this.setState({
          showData: true,
          showErr: true,
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
        });
        logData(err);
      });
    })
  }
  // handles input change and updates state
  handleChange = (e) => {
    this.setState({[e.target.name] : e.target.value});
  }
  // closes alert box
  handleAlertDismiss = () => {
    this.setState({
      showErr: false
    });
  }

  /**
   * toggles switch
   * @param  {object} el (optional Switch param)
   * @param  {boolean} state state of switch (optional)
   * @param  {string} name
   */
  handleSwitch = (el, state, name) => {
    if(name === 'busy_call_forward' || name === 'noanswer_call_forward') {
      if(this.state.call_forward !== true) {
        this.setState({[name]: !this.state[name]});
      }
    } else {
      this.setState({[name]: !this.state[name]});
    }
    if(name == 'call_forward' && this.state.call_forward == true) {
      this.setState({
        busy_call_forward : false,
        noanswer_call_forward : false
      })
    }
  }

  // submits conditional and inconditional redirects
  handleSubmit = () => {
    if(this.state.call_forward==true && this.state.phone.length==0){
      this.setState({
        errorMsg: 'Please enter phone number',
        showErr: true
      });
      return;
    } else if(this.state.busy_call_forward==true && this.state.busy_phone_call_forward.length==0){
      this.setState({
        errorMsg: 'Please enter phone number for (when its busy)',
        showErr: true
      });
      return;
    } else if(this.state.noanswer_call_forward==true &&
      (this.state.noanswer_phone_call_forward.length==0 || this.state.noanswer_time_call_forward.length==0)){
      this.setState({
        errorMsg: 'Please enter seconds and phone number for (if doesnt answer)',
        showErr: true
      });
      return;
    }else{
      // makes 2 api calls 1 after another
      this.props.setInconditionalDivert(this.state).then((res) => {
        if(res.data.result){
          setTimeout(() => {
            this.props.setConditionalDivert(this.state).then((res1) => {
              if(res1.data.result) {
                this.setState({
                  showErr: false
                }, () => {
                  this.props.handleClose(this.props.showRedirectionModal);
                });
              }else{
                this.setState({
                  errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
                  showErr: true
                });
              }
            }, (err1) => {
              this.setState({
                errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
                showErr: true
              });
              logData(err1);
            });
          }, 1000);
        }else{
          this.setState({
            errorMsg: res.data.description || this.props.translations.commonErrorText[this.props.selectedLanguage],
            showErr: true
          });
        }
      }, (err) => {
        this.setState({
          errorMsg: this.props.translations.commonErrorText[this.props.selectedLanguage],
          showErr: true
        });
        logData(err);
      });
    }
  }

  pasteValueHandler = (event) => {
    let pastehandlervalue = pasteHandler(event);
    this.setState({[event.target.name] : pastehandlervalue.value});
  }

  render(){
    const { translations, selectedLanguage } = this.props;
    return (
      <Modal
        dialogClassName="redirectModal"
        onEnter={this.getCallForwardStatus}
        show={this.props.showRedirectionModal}
        onHide={() => this.close('showRedirectionModal')}
        backdrop="static"
      >
        <Modal.Header className={`modal-content${this.props.theme} modal-header${this.props.theme}`} closeButton>
          <Modal.Title>{translations.callForwardingAndVoiceMail[selectedLanguage]}</Modal.Title>
        </Modal.Header>
        <Modal.Body className={`modal-content${this.props.theme}`} style={{overflow: 'auto'}}>
          {this.state.showErr && <div className="alertWrapper"><Alert bsStyle="danger" onDismiss={this.handleAlertDismiss}>
            <p>{this.state.errorMsg}</p>
          </Alert></div>}
          {!this.state.showData && <Loader width="20px" height="20px" />}
          {this.state.showData && <div style={{minWidth: 625}}>
            <div className="form-group row">
              <div className="col-xs-12">
                <Switch
                  bsSize="small"
                  value={this.state.call_forward}
                  onText={this.props.translations.yes[this.props.selectedLanguage]}
                  offText={this.props.translations.no[this.props.selectedLanguage]}
                  onColor="success"
                  offColor="danger"
                  onChange={(el, state) => this.handleSwitch(el, state, 'call_forward')}
                  name='call_forward'
                />
                <span style={ {marginLeft:'5px'} }>{translations.alwaysForward[selectedLanguage]}</span>
                <div style={{ display: 'inline-block', padding: '0 5px 0 5px'}}>
                  <input
                    onKeyDown={(event) => keyDownHandler(event, "allowNumbersAndChars")}
                    onPaste={(event) => this.pasteValueHandler(event, "allowNumbersAndChars")}
                    style={{ width: 150 }}
                    type="text"
                    name="phone"
                    className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                    value={this.state.phone}
                    onChange={(e) => this.handleChange(e, 'title')} />
                </div>
              </div>
            </div>
          <div className="form-group row">
            <div className="col-xs-12">
              <Switch
                bsSize="small"
                value={this.state.busy_call_forward && !this.state.call_forward}
                onText={this.props.translations.yes[this.props.selectedLanguage]}
                offText={this.props.translations.no[this.props.selectedLanguage]}
                onColor="success"
                offColor="danger"
                onChange={(el, state) => this.handleSwitch(el, state, 'busy_call_forward')}
                name='busy_call_forward'
              />
              <span style={ {marginLeft:'5px'} }>{translations.ifBusy[selectedLanguage]}</span>
              <div style={{ display: 'inline-block', padding: '0 5px 0 5px'}}>
                <input onKeyDown={(event) => keyDownHandler(event, "allowNumbersAndChars")} onPaste={(event) => this.pasteValueHandler(event, "allowNumbersAndChars")} style={{width:150}} type="text" name="busy_phone_call_forward" className={`form-control${this.props.theme} input-sm${this.props.theme}`} value={this.state.busy_phone_call_forward} onChange={(e) => this.handleChange(e, 'title')} />
              </div>
            </div>
          </div>
          <div className="form-group row">
            <div className="col-xs-12">
              <Switch
                bsSize="small"
                value={this.state.noanswer_call_forward && !this.state.call_forward}
                onText={this.props.translations.yes[this.props.selectedLanguage]}
                offText={this.props.translations.no[this.props.selectedLanguage]}
                onColor="success"
                offColor="danger"
                onChange={(el, state) => this.handleSwitch(el, state, 'noanswer_call_forward')}
                name='noanswer_call_forward'
              />
              <span style={ {marginLeft:'5px'} }>{translations.ifNoAsnwserPart1[selectedLanguage]}</span>
              <div style={{ display: 'inline-block', padding: '0 5px 0 5px'}}>
                  <input
                    onKeyDown={(event) => keyDownHandler(event, "allowOnlyNumbers")}
                    onPaste={(event) => this.pasteValueHandler(event, "allowOnlyNumbers")}
                    style={{ width: 50 }}
                    type="text"
                    name="noanswer_time_call_forward"
                    className={`form-control${this.props.theme} input-sm${this.props.theme}`}
                    value={this.state.noanswer_time_call_forward}
                    onChange={(e) => this.handleChange(e, 'title')}
                  />
              </div>
              <span>{translations.ifNoAsnwserPart2[selectedLanguage]}</span>
              <div style={{ display: 'inline-block', padding: '0 5px 0 5px'}}>
                <input onKeyDown={(event) => keyDownHandler(event, "allowNumbersAndChars")} onPaste={(event) => this.pasteValueHandler(event, "allowNumbersAndChars")} style={{width:150}} type="text" name="noanswer_phone_call_forward" className={`form-control${this.props.theme} input-sm${this.props.theme}`} value={this.state.noanswer_phone_call_forward} onChange={(e) => this.handleChange(e, 'title')} />
              </div>
            </div>
            {/* <div className="form-group col-md-4">
              <input type="text" name="noanswer_phone_call_forward" className="form-control" value={this.state.noanswer_phone_call_forward} onChange={(e) => this.handleChange(e, 'title')} />
            </div> */}
          </div>
        </div>}
        </Modal.Body>
        <Modal.Footer className={`modal-content${this.props.theme}`}>
          <button type="button" onClick={() => this.close('showRedirectionModal')} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">{translations.cancel[selectedLanguage]}</button>
          <button type="submit" onClick={() => this.handleSubmit()} className={`btn-link btn-link${this.props.theme} modal-action${this.props.theme}`} data-dismiss="modal">
            <strong>{translations.save[selectedLanguage]}</strong>
          </button>
        </Modal.Footer>
      </Modal>
    )
  }
}

function mapStateToProps  (state) {
    return {
        agentConfig: state.agentConfig,
        callForward: state.callForward,
        translations: state.languages.translations,
				selectedLanguage: state.languages.selectedLanguage,
        darkMode: state.common.darkMode,
        theme: state.common.theme,
    };
}

function mapDispatchToProps (dispatch) {
    return bindActionCreators({getCallForward,setInconditionalDivert,setConditionalDivert}, dispatch);
}

export default connect(mapStateToProps,mapDispatchToProps)(EditRedirectModal);



// WEBPACK FOOTER //
// ./src/agent/modals/editRedirect.js